import { render, staticRenderFns } from "./WhiteBackgroundDetail.vue?vue&type=template&id=2b40a3e0&scoped=true"
import script from "./WhiteBackgroundDetail.vue?vue&type=script&lang=js"
export * from "./WhiteBackgroundDetail.vue?vue&type=script&lang=js"
import style0 from "./WhiteBackgroundDetail.vue?vue&type=style&index=0&id=2b40a3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b40a3e0",
  null
  
)

export default component.exports